export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9.5 5.134a1 1 0 0 1 0 1.732L5 9.464a1 1 0 0 1-1.5-.866V3.402A1 1 0 0 1 5 2.536l4.5 2.598z" fill="#614FAA" />
	</svg>
);
